// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"c72995b2808d432639ff","532":"6851bfb4b37b18e47634","678":"62472ceb9e8422204e0f","883":"0e6aa8dd36a06f96c743"}[chunkId] + ".js";
};